import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Prestation, PrestationStatut, PrestationStatutString, StatutBeneficiaireString } from 'src/app/shared/models/prestation';
import { SortOrder } from 'src/app/shared/pipes/order-by/order-by.pipe';
import {
	PrestationType,
	PrestationTypeString
} from 'src/app/shared/models/prestation';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { ActivitePrestationModalAjoutComponent } from '../activitePrestation/activitePrestation-modal-ajout/activitePrestation-modal-ajout.component';
import { PrestationModalDetailActivitePrestationComponent } from '../modal/prestation-modal-detail-activitePrestation/prestation-modal-detail-activitePrestation.component';

@Component({
	selector: 'app-detail-prestation',
	templateUrl: './detail-prestation.component.html',
	styleUrls: ['./detail-prestation.component.scss']
})
export class DetailInfosasComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z'éèàç._-]+( [0-9a-zA-Z'éèàç._-]+)*$");

	prestation: Prestation = null;
	confirmDeleteModalRef: BsModalRef;
	competences;
	isDeletable: boolean;
	currentPage = 1;

	suiviPrestationList : SuiviPrestation[];
	currentPageSuivi = 1;
	sortOrderSuivi: SortOrder = 'asc';
	detailSuiviPrestationModalRef: BsModalRef;
	ajoutSuiviModalref: BsModalRef;

	activitePrestationList : ActivitePrestation[];
	currentPageActivite = 1;
	sortOrderActivite: SortOrder = 'asc';
	detailActivitePrestationModalRef: BsModalRef;
	ajoutActiviteModalref: BsModalRef;
	
	labelIntervenantCapitalized: string;

	isFormReadOnly = true;

	itemsPerPage = 10;
	isListingLoadingSuivi: boolean = true;
	isListingLoadingActivite: boolean = true;
	isAddable = true;

	prestationDetailForm = new FormGroup({
		dateDebut: new FormControl<Date>(null, Validators.required),
		dateAr: new FormControl<Date>(null),
		dateFin: new FormControl<Date>(null),
		statut: new FormControl(''),
		prescripteur: new FormControl(),
		deDispositifs: new FormControl(''),
		deContraintesHandicap: new FormControl(''),
		deProjetPro: new FormControl(''),
		deRuptureParcours: new FormControl(''),
		deBesoinsIdent: new FormControl(''),
		eeLimites: new FormControl(''),
		eeQuestEmploi: new FormControl(''),
		eeBesoinsAdapt: new FormControl(''),
		eePbAccess: new FormControl(''),
		eeAccompDejaMene: new FormControl(''),
		efLimiteCapacite: new FormControl(''),
		efQuestionnement: new FormControl(''),
		efAccessibilite: new FormControl(''),
		efTypeFormation: new FormControl(),
		efBesoinsAt: new FormControl(''),
		statutBeneficiaire: new FormControl(''),
		canalCommunication: new FormControl(''),
		nombreDemande: new FormControl(''),
    	demandePrescripteur: new FormControl(''),
   		reponseDemande: new FormControl(''),
    	typologieDemande: new FormControl(''),
    	situationGeographique: new FormControl(''),
    	typeHandicap: new FormControl(),
		motifRefus: new FormControl(''),
		reorientation: new FormControl(),
		organismeReorientation: new FormControl(''),
		contactReorientation: new FormControl(''),
		argumentaire: new FormControl(''),
		numeroCommande: new FormControl(''),
	});

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	//Employé.e extérieur
	isEmpExt = false;

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationType = PrestationType;

	public PrestationStatutStringEnum = PrestationStatutString;
	public PrestationStatut = PrestationStatut;

	public StatutBeneficiaireStringEnum = StatutBeneficiaireString;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.isDeletable = true;

		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.infosasService
			.getInfosasById(id)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
				this.facade.suiviPrestationService.getByPrestation(this.prestation.id).subscribe({
					next: (val) => {
						this.suiviPrestationList = val;
					}
				});
				this.facade.activitePrestationService.getByPrestation(this.prestation.id).subscribe({
					next: (val) => {
						this.activitePrestationList = val;
					}
				});
			});
	}

	goBack(): void {
		this.router.navigate(['/prestation/infosas/list']);
	}

	delete(prestation: Prestation): void {
		if (this.isDeletable) {
			this.facade.prestationService.deletePrestation(prestation.id).subscribe({
				complete: () => {
					this.modalService.hide();
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.modalService.hide();
				}
			});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;

		if (isSubmit) {
			this.facade.prestationService.getPrestationById(this.prestation.id).subscribe({
				next: (prestation: Prestation) => {
					this.prestation = prestation;
					this.resetForm();
				},
				error: (err) => {
					this.isValidateButtonClicked.value = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.resetForm();
				}
			});
		}
	}

	onSubmit() {
		if (
			this.prestationDetailForm.valid
		){
			console.log(this.prestation.modules);
				   this.facade.infosasService.updateInfosas(this.prestation).subscribe({
						next: (val) => { 
							if(this.prestation.modules?.length > 0){
								this.prestation.modules.forEach((currentValue) => {
									switch(currentValue) { 
										case PrestationType.AC: {
											let ac = new Prestation();
											ac.statut = this.PrestationStatut.OUVERT;
											ac.beneficiaire = this.prestation.beneficiaire;
											ac.typePrestation = this.prestation.typePrestation;
											ac.service = this.facade.dataStorageService.getService();
											ac.idQualification = val.id;
											 
											this.facade.capaciteService.addCapacite(ac).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.AS: {
											let as = new Prestation();
											as.statut = this.PrestationStatut.OUVERT;
											as.beneficiaire = this.prestation.beneficiaire;
											as.typePrestation = this.prestation.typePrestation;
											as.service = this.facade.dataStorageService.getService();
											as.idQualification = val.id;
											 
											this.facade.situationPrestationService.addSituationPrestation(as).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.CAMEO: {
											let cameo = new Prestation();
											cameo.statut = this.PrestationStatut.OUVERT;
											cameo.beneficiaire = this.prestation.beneficiaire;
											cameo.typePrestation = this.prestation.typePrestation;
											cameo.service = this.facade.dataStorageService.getService();
											cameo.idQualification = val.id;
											 
											this.facade.miseEnOeuvreEmploiService.addMiseEnOeuvreEmploi(cameo).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.EAP: {
											let eap = new Prestation();
											eap.statut = this.PrestationStatut.OUVERT;
											eap.beneficiaire = this.prestation.beneficiaire;
											eap.typePrestation = this.prestation.typePrestation;
											eap.service = this.facade.dataStorageService.getService();
											eap.idQualification = val.id;
											 
											this.facade.evaluationService.addEvaluation(eap).subscribe({
												next: (val) => {
												}
											});
											break;
										}
										case PrestationType.SP: {
											let sp = new Prestation();
											sp.statut = this.PrestationStatut.OUVERT;
											sp.beneficiaire = this.prestation.beneficiaire;
											sp.typePrestation = this.prestation.typePrestation;
											sp.service = this.facade.dataStorageService.getService();
											sp.idQualification = val.id;
											 
											this.facade.suiviPrecoService.addSuiviPreco(sp).subscribe({
												next: (val) => {
												}
											});
											break;
										}
									}
								})
							}
						},
						complete:()=>{
							this.stopEditForm(true);
						},
						error: (err: ErrorResponse) => {
							this.isValidateButtonClicked.value = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.message ? err.error.message : '',
								err.status
							);
							// On va chercher la nouvelle version de l'employé
							this.facade.situationPrestationService
								.getSituationPrestationById(this.prestation.id)
								.subscribe((prestation: Prestation) => {
									this.prestation = prestation;
									this.resetForm();
								});
						}
					});
				
		} else {
			this.isValidateButtonClicked.value = false;
			// this.facade.toastService.createErrorToast();
		}
	}

	resetForm() {
		this.prestationDetailForm.reset();
		this.prestationDetailForm.patchValue({
			statut: this.prestation.statut,
			dateDebut:
				this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
					? new Date(this.prestation.dateDebut)
					: null,
			dateAr:
					this.prestation.dateAr !== null && this.prestation.dateAr !== ''
						? new Date(this.prestation.dateAr)
						: null,
			dateFin:
			this.prestation.dateFin !== null && this.prestation.dateFin !== ''
					? new Date(this.prestation.dateFin)
					: null,
			deDispositifs: this.prestation.deDispositifs,
			deContraintesHandicap: this.prestation.deContraintesHandicap,
			deProjetPro: this.prestation.deProjetPro,
			deRuptureParcours: this.prestation.deRuptureParcours,
			deBesoinsIdent: this.prestation.deBesoinsIdent,
			eeLimites: this.prestation.eeLimites,
			eeQuestEmploi: this.prestation.eeQuestEmploi,
			eeBesoinsAdapt: this.prestation.eeBesoinsAdapt,
			eePbAccess: this.prestation.eePbAccess,
			eeAccompDejaMene: this.prestation.eeAccompDejaMene,
			efLimiteCapacite: this.prestation.efLimiteCapacite,
			efQuestionnement: this.prestation.efQuestionnement,
			efAccessibilite: this.prestation.efAccessibilite,
			efTypeFormation: this.prestation.efTypeFormation,
			efBesoinsAt: this.prestation.efBesoinsAt,
			statutBeneficiaire: this.prestation.statutBeneficiaire,
			motifRefus: this.prestation.motifRefus,
			demandePrescripteur: this.prestation.demandePrescripteur,
			reponseDemande: this.prestation.reponseDemande,
			typeHandicap: this.prestation.typeHandicap,
			situationGeographique: this.prestation.situationGeographique,
			reorientation: this.prestation.reorientation,
			organismeReorientation: this.prestation.organismeReorientation,
			contactReorientation: this.prestation.contactReorientation,
			argumentaire: this.prestation.argumentaire,
			numeroCommande: this.prestation.numeroCommande
		})
	}

	openModalDetailActivite(activitePrestation: ActivitePrestation): void {
		const initialState = {
			activitePrestation: activitePrestation,
			prestation: this.prestation
		};
		this.detailActivitePrestationModalRef = this.modalService.show(
			PrestationModalDetailActivitePrestationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	// intervenantAsString() {
	// 	let str = '';
	// 	this.prestation.intervenants.sort((a, b) => a.name.localeCompare(b.name))
	// 		.forEach((e) => (str += e.name + ', '));
	// 	return str.slice(0, -2);
	// }

	get dateDebut() {
		return this.prestationDetailForm.get('dateDebut');
	}
	get dateAr() {
		return this.prestationDetailForm.get('dateAr');
	}
	get dateFin() {
		return this.prestationDetailForm.get('dateFin');
	}
	get statut() {
		return this.prestationDetailForm.get('statut');
	}
	get intervenants() {
		return this.prestationDetailForm.get('intervenants');
	}
	get prescripteur() {
		return this.prestationDetailForm.get('prescripteur');
	}
	get deContraintesHandicap() {
		return this.prestationDetailForm.get('deContraintesHandicap');
	}
	get deDispositifs() {
		return this.prestationDetailForm.get('deDispositifs');
	}
	get deProjetPro() {
		return this.prestationDetailForm.get('deProjetPro');
	}
	get deRuptureParcours() {
		return this.prestationDetailForm.get('deRuptureParcours');
	}
	get deBesoinsIdent() {
		return this.prestationDetailForm.get('deBesoinsIdent');
	}
	get eeLimites() {
		return this.prestationDetailForm.get('eeLimites');
	}
	get eeQuestEmploi() {
		return this.prestationDetailForm.get('eeQuestEmploi');
	}
	get eeBesoinsAdapt() {
		return this.prestationDetailForm.get('eeBesoinsAdapt');
	}
	get eePbAccess() {
		return this.prestationDetailForm.get('eePbAccess');
	}
	get eeAccompDejaMene() {
		return this.prestationDetailForm.get('eeAccompDejaMene');
	}
	get efLimiteCapacite() {
		return this.prestationDetailForm.get('efLimiteCapacite');
	}
	get efQuestionnement() {
		return this.prestationDetailForm.get('efQuestionnement');
	}
	get efAccessibilite() {
		return this.prestationDetailForm.get('efAccessibilite');
	}
	get efTypeFormation() {
		return this.prestationDetailForm.get('efTypeFormation');
	}
	get efBesoinsAt() {
		return this.prestationDetailForm.get('efBesoinsAt');
	}
	get statutBeneficiaire() {
		return this.prestationDetailForm.get('statutBeneficiaire');
	}
	get nombreDemande() {
		return this.prestationDetailForm.get('nombreDemande');
	}
	get demandePrescripteur() {
		return this.prestationDetailForm.get('demandePrescripteur');
	}
	get reponseDemande() {
		return this.prestationDetailForm.get('reponseDemande');
	}
	get typologieDemande() {
		return this.prestationDetailForm.get('typologieDemande');
	}
	get situationGeographique() {
		return this.prestationDetailForm.get('situationGeographique');
	}
	get typeHandicap() {
		return this.prestationDetailForm.get('typeHandicap');
	}
	get motifRefus() {
		return this.prestationDetailForm.get('motifRefus');
	}
	get reorientation() {
		return this.prestationDetailForm.get('reorientation');
	}
	get organismeReorientation() {
		return this.prestationDetailForm.get('organismeReorientation');
	}
	get contactReorientation() {
		return this.prestationDetailForm.get('contactReorientation');
	}
	get argumentaire() {
		return this.prestationDetailForm.get('argumentaire');
	}
	get numeroCommande() {
		return this.prestationDetailForm.get('numeroCommande');
	}

	getSuivis(): void {
		this.isListingLoadingSuivi = true;
		this.facade.suiviPrestationService.getByPrestation(this.prestation.id).subscribe({
			next: (suivis: SuiviPrestation[]) => {
				this.suiviPrestationList = suivis;
				console.log(this.suiviPrestationList);
				//this.listIntervenants = this.getPrestationsIntervenants(this.prestations);
				this.currentPageSuivi = 1;
				this.itemsPerPage = this.suiviPrestationList.length >= 5 ? 10 : 5;

				this.isListingLoadingSuivi = false;
			},
			error: (err: ErrorResponse) => {
				//this.logger.error(err + '');
				this.isListingLoadingSuivi = false;
			}
		});
	}

	getActivites(): void {
		this.isListingLoadingActivite = true;
		this.facade.activitePrestationService.getByPrestation(this.prestation.id).subscribe({
			next: (activites: ActivitePrestation[]) => {
				this.activitePrestationList = activites;
				console.log(this.activitePrestationList);
				this.currentPageActivite = 1;
				this.itemsPerPage = this.activitePrestationList.length >= 5 ? 10 : 5;

				this.isListingLoadingActivite = false;
			},
			error: (err: ErrorResponse) => {
				//this.logger.error(err + '');
				this.isListingLoadingActivite = false;
			}
		});
	}

	openModalActivitePrestationAjout() {
		const initialState = {};
		this.ajoutActiviteModalref = this.modalService.show(
			ActivitePrestationModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutActiviteModalref.onHide.subscribe((reason: string | any) => {
			this.getActivites();
		});
	}
	
}
